import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import {
  CardValue,
  DataTable,
  EntitySelector,
  StyledButton,
  CheckBox,
  InfoTooltip
} from "components/support";
import { FormattedNumber } from "react-intl";
import Typography from "material-ui-next/Typography";
import Paper from "material-ui-next/Paper";

export default class DataTableView extends Component {
  config = () => ({
    identifier: "code",
    columns: [
      {
        id: "product_xml",
        type: "custom",
        Header: "Produto no XML",
        sortable: false,
        minWidth: 125,
        Cell: props => {
          const product = props.original;

          return (
            <div>
              <strong>{product.name}</strong>
              <div style={{ fontSize: "0.85em" }}>
                <FormattedNumber value={product.quantity.div(100)} />
                <span>{product.unitLabel}</span>
                <br />
                <span>Valor: </span>
                <FormattedNumber value={product.value.div(100)} format="BRL" />
              </div>
            </div>
          );
        }
      },
      {
        id: "product_import",
        sortable: false,
        acessor: "importSellable.name",
        type: "custom",
        Header: "Produto Importado",
        minWidth: 100,
        Cell: props => {
          const { sellableSearchOptions, onUpdateItem } = this.props;
          const product = props.original;

          return (
            <EntitySelector
              title="Selecionar Produto"
              placeholder="Selecione um produto"
              textDisabled={product.importSellable.name}
              value={product.importSellable.name}
              searchOptions={sellableSearchOptions}
              onSelect={sellable =>
                onUpdateItem(product.index, "importSellable", sellable)
              }
              nullSelection={{ name: "", uuid: null }}
              parser={sellable => ({
                key: sellable.uuid,
                title: sellable.name
              })}
              errorText={product.errors.importSellable}
              noMargin
            />
          );
        }
      }
    ]
  });

  render() {
    const { products, onImport, page, onPageChange, onCancel, importSellableCode, onImportSellableCodeChange } = this.props;
    const pageStart = 25 * (page - 1);
    const pageEnd = 25 * page;
    const pageData = products.slice(pageStart, pageEnd);

    return (
      <Paper elevation={1} className="product__content">
        <div style={{ padding: 8 }}>
          <Typography type="headline" style={{ marginBottom: 10 }}>
            2ª Etapa - Verificar produtos
          </Typography>
          <CardValue small style={styles.pararaphMargin}>
            Agora realize a associação entre os produtos presentes no XML e o
            que será importado no sistema.
          </CardValue>
          <CardValue small style={styles.pararaphMargin}>
            Produtos que não forem associados serão criados automaticamente no
            estoque.
          </CardValue>
          <CardValue small style={styles.pararaphMargin}>
            Para venda de produtos novos, é necessário após a importação
            verificar se os atributos obrigatórios estão preenchidos.
          </CardValue>
          <CardValue small style={styles.pararaphMargin}>
            Produtos iguais serão agrupados em um único produto.
          </CardValue>
        </div>

        <div style={styles.importCodeArea}>
          <CheckBox
            style={styles.importCodeAreaCheckbox}
            checked={importSellableCode}
            label={"Importar código do produto"}
            labelStyle={{ margin: 0 }}
            onCheck={onImportSellableCodeChange}
          />
          <InfoTooltip hint="Caso não seja importado, um código único será gerado automaticamente" />
        </div>

        <DataTable
          manual
          resultSet={pageData}
          total={products.length}
          page={page}
          perPage={25}
          config={this.config()}
          onPageChange={page => onPageChange(page + 1)}
        />

        <Row end="xs" style={{ padding: 10 }}>
          <Col>
            <StyledButton label="Cancelar" onClick={onCancel} />
          </Col>
          <Col>
            <StyledButton primary label="Importar" onClick={onImport} />
          </Col>
        </Row>
      </Paper>
    );
  }
}

const styles = {
  importCodeArea: {
    display: 'flex',
    alignItems: 'center',
    padding: "16px 8px",
    borderTop: "1px solid rgba(0,0,0,0.1)"
  },
  importCodeAreaCheckbox:{
    margin: 0,
    display: 'inline-flex',
    alignItems: 'center'
  },
  pararaphMargin: {
    margin: "5px 0"
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/xml/data-table/index.js